import AccountManagementLayout from "../components/layout/AccountManagementLayout";
import { connect } from "react-redux";

export function mapStateToProps(state, ownProps) {
    return {
        bloombergSiteUrl: state.config.bloombergSiteUrl,
        location: ownProps.location
    };
}

const AccountManagementLayoutContainer = connect(
    mapStateToProps,
    () => ({})
)(AccountManagementLayout);

export default AccountManagementLayoutContainer;
